import { render, staticRenderFns } from "./GuidelineRecorder.vue?vue&type=template&id=0b1f9331&"
import script from "./GuidelineRecorder.vue?vue&type=script&lang=ts&"
export * from "./GuidelineRecorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports